import React from 'react';
import { FRETE_LABELS } from '../constants';
import { StyledCard, CardTitle, FormGrid, StyledFormGroup, TooltipWrapper, InfoIcon } from '../cardStyles';

interface Props {
  invoice: any;
  readOnly?: boolean;
}

const LabelWithInfo = ({ label, tooltip }: { label: string; tooltip: string }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <label style={{ marginBottom: 0 }}>{label}</label>
    <TooltipWrapper data-tooltip={tooltip}>
      <InfoIcon>i</InfoIcon>
    </TooltipWrapper>
  </div>
);

const FreteSection: React.FC<Props> = ({ invoice }) => (
  <StyledCard>
    <CardTitle>Frete</CardTitle>
    <FormGrid cols={2}>
      <StyledFormGroup>
        <LabelWithInfo label="Modalidade" tooltip="Modalidade de frete definida na nota" />
        <input
          type="text"
          readOnly
          value={invoice?.modalidadeFrete ? (FRETE_LABELS[invoice.modalidadeFrete] || invoice.modalidadeFrete) : '—'}
        />
      </StyledFormGroup>
      <StyledFormGroup>
        <LabelWithInfo label="Transportadora" tooltip="Transportadora vinculada à nota" />
        <input type="text" readOnly value={invoice?.CompanyTransportadora?.companyName || '—'} />
      </StyledFormGroup>
    </FormGrid>
  </StyledCard>
);

export default FreteSection;
